import React from "react";
import {connect} from "react-redux";
import {formVisible} from "../actions";

const Component = ({onClick}) => (
    <button type="button" className="btn btn-info" onClick={onClick}>Оставить заявку</button>
);

export const ButtonCustom = connect(
    state => ({}),
    dispatch => ({
        onClick: () => dispatch(formVisible(true, 'custom'))
    })
)(Component);

export const ButtonBergen = connect(
    state => ({}),
    dispatch => ({
        onClick: () => dispatch(formVisible(true, 'bergen'))
    })
)(Component);


// WEBPACK FOOTER //
// ./src/custom_course/containers/Button.js